export const PUBLIC_ROUTES = ["/", "/login", "/signup", "/login/offer", "/survey"];

export const RESPONSIVE_ROUTES = [
  ...PUBLIC_ROUTES,
  "/plans",
  "/settings",
  "/integrations",
  "/membership",
  "/user/preferences",
  "/payment-subscription/cancel",
  "/payment-subscription/success",
  "/payment/:status",
];

export const SKIP_ROUTES = ["/settings", "/user/preferences", "/survey"];
